module.exports = __webpack_public_path__ + "img/ExtensionOffOutlined.98f61f30.svg";